import { render, staticRenderFns } from "./ResumoCadastro.vue?vue&type=template&id=3bf1d6a0&scoped=true&"
import script from "./ResumoCadastro.vue?vue&type=script&lang=js&"
export * from "./ResumoCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ResumoCadastro.vue?vue&type=style&index=0&id=3bf1d6a0&prod&lang=css&"
import style1 from "./ResumoCadastro.vue?vue&type=style&index=1&id=3bf1d6a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1d6a0",
  null
  
)

export default component.exports